import React, { useEffect, useState } from 'react';
import axios from 'axios';
import './AdminMessages.css';

const AdminMessages = () => {
  const [messages, setMessages] = useState([]);

  const fetchMessages = async () => {
    try {
      const res=await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/admin/messages`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('adminToken')}`,
        },
      });
      setMessages(res.data);
    } catch (err) {
      console.error('Failed to fetch messages:', err);
    }
  };

  const markAsSolved = async (id) => {
    try {
      await axios.put(`${process.env.REACT_APP_API_BASE_URL}/api/admin/messages/${id}/solve`, {}, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('adminToken')}`
        }
      });
      setMessages(prev =>
        prev.map(msg => (msg._id === id ? { ...msg, solved: true } : msg))
      );
    } catch (err) {
      console.error('Failed to mark as solved:', err);
    }
  };

  const handleDelete = async (id) => {
    try {
      await axios.delete(`${process.env.REACT_APP_API_BASE_URL}/api/admin/messages/${id}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('adminToken')}`
        }
      });
      setMessages(prev => prev.filter(msg => msg._id !== id));
    } catch (err) {
      console.error('Failed to delete message:', err);
      alert('Delete failed. Please try again.');
    }
  };

  useEffect(() => {
    fetchMessages();
  }, []);

  return (
    <div className="messages-page">
      <h2>User Messages</h2>
      <div className="mobile-warning">
      For the best experience and all features, please use a PC or laptop
      </div>
      <table className="messages-table">
        <thead>
          <tr>
            <th className="subs-hide">S.No.</th>
            <th>Name</th>
            <th className="subs-hide">Email</th>
            <th>Message</th>
            <th className="subs-hide">Submitted At</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          {messages.map((msg, idx) => (
            <tr key={msg._id} className={msg.solved ? 'solved' : ''}>
              <td className="subs-hide">{idx + 1}</td>
              <td>{msg.name}</td>
              <td className="subs-hide">{msg.email}</td>
              <td>{msg.message}</td>
              <td className="subs-hide">{new Date(msg.createdAt).toLocaleString()}</td>
              <td>
                {msg.solved ? (
                  <>
                    <span className="solved-tag">✅ Solved</span>
                    <button
                      className="delete-btn"
                      onClick={() => handleDelete(msg._id)}
                    >
                      Delete
                    </button>
                  </>
                ) : (
                  <button onClick={() => markAsSolved(msg._id)}>Mark as Solved</button>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default AdminMessages;
